import React from "react";

import { IActiveLearningMaterial } from "../../state";
import Button from "../../atoms/ActiveLearning/Button";

import styles from "./activeLearningMaterial.module.scss";

export interface ActiveLearningMaterialProps {
  active_learning_material: IActiveLearningMaterial;
  openGuideline: (teaching_material_id: string, lesson_id: number) => void;
  openProjection: (teaching_material_id: string, lesson_id: number) => void;
  calling: boolean;
}

const ActiveLearningMaterial = ({
  active_learning_material,
  openGuideline,
  openProjection,
}: ActiveLearningMaterialProps) => {
  const goToNextScreen = React.useCallback(
    (lessonId: number) => {
      openGuideline(active_learning_material?.mitsuwa_id || "", lessonId);
    },
    [openGuideline, active_learning_material.mitsuwa_id],
  );
  const goToProjection = React.useCallback(
    (lessonId: number) => {
      openProjection(active_learning_material?.mitsuwa_id || "", lessonId);
    },
    [openProjection, active_learning_material.mitsuwa_id],
  );

  return (
    <div className={styles.activeLearningMaterial}>
      {active_learning_material.lessons?.map(l => (
        <div key={l.id} className={styles.lesson}>
          <div className={styles.label}>
            {l.no !== 0 && (
              <>
                <span className={styles.text}>LESSON</span>
                <span className={styles.no}>
                  {l.no && l.no < 10 ? `0${l.no}` : l.no}
                </span>
              </>
            )}
          </div>
          <div className={styles.title}>{l.title}</div>
          <div className={styles.btnWrapper}>
            <Button
              variant={"primary"}
              width={"74px"}
              height={"37px"}
              fontSize={"14px"}
              handleClick={() => goToNextScreen(l.id)}
            >
              指導書
            </Button>
            {l.no !== 0 && (
              <Button
                variant={"secondary"}
                width={"88px"}
                height={"37px"}
                fontSize={"14px"}
                handleClick={() => goToProjection(l.id)}
              >
                投影画面
              </Button>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ActiveLearningMaterial;
